<template>
  <div class="template-steps-with-numbers">
    <div class="content pb-5 pt-3">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <MaterialHeader :content="content"/>
            <h2 class="text-primary bold mb-2 material-title"
                v-html="content.title.rendered"></h2>
            <p class="material-subtitle text-secondary">{{content.acf.subtitle}}</p>
            <div class="introduction mb-5 pt-3" v-if="content.acf.introduction.text">
              <div class="d-flex justify-content-start align-items-start align-items-md-center">
                <img v-if="content.acf.introduction.icon" :src="content.acf.introduction.icon" class="icon">
                <p class="m-0">
                  {{content.acf.introduction.text}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <div class="row">
            <div class="col-12">
              <p class="mb-3 text-before-steps">{{content.acf.text_before_steps}}</p>
            </div>
          </div>
          <div class="steps">
            <template v-for="(step, i) in content.acf.steps" >
              <div v-if="step.step_title" :key="`step-${i}`" class="step">
                <div class="row">
                  <div class="col-12">
                    <h3 class="pointer d-flex justify-content-between align-items-center"
                        v-b-toggle="`collapse-step-${i}`">
                      <span class="step-title">
                        <span class="text-secondary mr-3">{{formatStepNumber(i)}}</span>
                        <span class="bold">{{step.step_title}}</span>
                      </span>
                      <span :class="{'d-none': documentGenerating}">
                        <img src="@/assets/icons/plus-secondary-thin.svg" class="img-fluid when-closed">
                        <img src="@/assets/icons/arrow-primary.svg" class="img-fluid when-open">
                      </span>
                    </h3>
                    <b-collapse :id="`collapse-step-${i}`" :visible="documentGenerating">
                      <div class="step-content mt-2">
                        <div v-html="step.step_content"></div>
                        <div v-if="step.step_pictures.length">
                          <Gallery :images="step.step_pictures"/>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="text-after-steps col-12" v-if="content.acf.text_after_steps">
              <div v-html="content.acf.text_after_steps" class="mt-5"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="content.acf.downloads.files">
      <Downloads :content="content.acf.downloads" />
    </div>
  </div>
</template>

<script>
import Downloads from '@/templates/template-parts/Downloads.vue';
import MaterialHeader from '@/templates/template-parts/MaterialHeader.vue';
import Gallery from '@/templates/template-parts/Gallery.vue';

export default {
  props: {
    content: Object,
    documentGenerating: null,
  },
  data() {
    return {
      lightboxItems: [],
      lightboxIndex: null,
    };
  },
  components: {
    Downloads,
    MaterialHeader,
    Gallery,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.material-subtitle {
  font-size: 25px;
}
@include media-breakpoint-down(lg) {
  .material-title {
    font-size: 24px;
  }
  .material-subtitle {
    font-size: 20px;
  }
}
.introduction {
  img {
    width: 100%;
    max-width: 65px;
    margin-right: 25px;
  }
}
.introduction,
.text-before-steps {
  font-size: 16px;
}
.steps {
  .step {
    &:first-of-type {
      border-top: 1px solid $secondary;
    }
    border-bottom: 1px solid $secondary;
    h3 {
      font-size: 20px;
      margin: 0;
      padding: .9em 0 .9rem .5rem;
      .step-title {
        display: flex;
      }
      img {
        width: 15px;
        margin: 0 10px 0 10px;
      }
      &:focus {
        outline: 0;
      }
      img.when-open {
        transform: rotate(-90deg);
      }
      &.collapsed img.when-open,
      &.not-collapsed img.when-closed {
        display: none;
      }
    }
    .step-content {
      padding: 0 55px 20px 46px;
      @include media-breakpoint-down(sm) {
        padding: 0 0 10px 0;
      }
      ::v-deep img {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
.text-after-steps {
  &::v-deep p {
    margin: 0;
  }
}
::v-deep ul {
  @extend .list-square;
}
</style>
